/* eslint-disable no-undef */

'use strict';

const Affirm = {
  updateAffirmPrice(newAffirmPrice) {
    const el = document.querySelector('.affirm-as-low-as');
    if (el === null) {
      return;
    }
    el.setAttribute('data-amount', newAffirmPrice);
    affirm.ui.refresh();
  },
  displayBannerInCalendar() {
    const el = document.querySelector('.affirm-section');
    return el ? (el.style.display = 'block') : undefined;
  },
  removeBanner() {
    const el = document.querySelector('.affirm-section');
    return el ? el.remove() : undefined;
  },
};
module.exports = Affirm;
